module.exports = __webpack_public_path__ + "img/CellCycle-PDAC_GSE205354.1633e3ee.png";